export enum ResequenceRequestStatus {
  RESEQUENCE_REQUEST_NO_REQUEST = "",
  RESEQUENCE_REQUEST_NEED_RESEQUENCE = "need_resequence",
  RESEQUENCE_REQUEST_COMPLETED = "completed",
}
